// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vYmP0","light":"styles_light__k9L2Z","primary":"styles_primary__zKhz0","secondary":"styles_secondary__S21EL"};